<script>
import crud from '@/crud/index/index'
import resources from './resources'

export default {
  name: 'professional-documents-index',
  mixins: [crud, resources]
}
</script>

<template lang="pug">
  page(title="Termo de uso", icon="")
    .col-xs-12.content
      .container-fluid
        section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget
          .actions
          div(style="overflow-y: scroll; max-height:350px; padding: 20px", v-for="term in terms")
            div(v-html="term.document_legal")
</template>



// WEBPACK FOOTER //
// src/app/patient/terms/index/index.vue